import React, { useState, useRef } from "react";
import {
  DatePicker,
  Form,
  Modal,
  Popover,
  Select,
  message,
  Input,
  Pagination,
  Skeleton,
} from "antd";

import { useSelector, useDispatch } from "react-redux";
import { Radio } from "antd";
import { useEffect } from "react";
import Spinner from "react-bootstrap/Spinner";
import { ADMIN_USER, USER_DATA } from "../../constants/const";
import { getFromLocalStorage } from "../../Helpers/localStorageHelper";
import moment from "moment";
import { createTimeSlots } from "../../Helpers/DateHelpers";
import { createDropdownValues } from "../../Helpers/helperFunctions";
import Assets from "../Layout/Assets";
import {
  FETCH_ADMIN_DASHBOARD_REPORT,
  fetch_doctors_list,
  acceptrejectrequest,
  FETCH_REQUEST_DASHBOARD_REPORT,
  changerequeststatus,
  fetch_doctors_list_bySpeciality,
} from "../../actions/ClinicAdminAction";
import {
  
  getdoctorbyspeciality
} from "../../actions/Quickbooking";
import { fetchgangaSpeciality, fetchallSpeciality} from "../../actions/SpecialityListingAction";

import { AssetStore } from "../../assets/AssetsStore";
import styles from "../InterbranchAdminComponents/RequestedAppointments/index.module.scss";
import "./index.css";
import { color } from "@mui/system";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import { Tooltip } from "antd";
import { fetchVisitHistory } from "../../actions/ConsultationAction";
import { format, parse } from "date-fns";

import { FALSE } from "sass";
const RadioGroup = Radio.Group;

function TodaysReportModalContent(handleTableRefresh) {
  const dispatch = useDispatch();
  let [appointments, setAppointments] = useState({});
  let [acceptModal, setAcceptModal] = useState(false);
  let [reassignModal, setReassignModal] = useState(false);
  let [inprogressModal, setInprogressModal] = useState(false);
  let [rejectModal, setRejectModal] = useState(false);
  let [reAssignData, setReassignData] = useState({});
  let [requestedData, setRequestedData] = useState({});
  let [processdone, setProcessdone] = useState(false);
  let [activePage, setActivePage] = useState(1);
  const [userType, setUserType] = useState();
  let [loader, setLoader] = useState(true);
  let [totalnoofpages, setTotalnoofpages] = useState(0);
  let [isInitial, setinitial] = useState(true);
  let [appointmentDetails, setAppointmentDetails] = useState({});
  let [visitDetails, setVisitDetails] = useState({});
  const [visitsToShow, setVisitsToShow] = useState(5);
  const [showLessButton, setShowLessButton] = useState(false);

  // useEffect(() => {
  //   let requestID = localStorage.getItem("reqid");
  //   dispatch(FETCH_REQUEST_DASHBOARD_REPORT(requestID)).then((res) => {
  //     setAppointmentDetails(res);
  //     //loaddoctors();
  //     setLoader(false);
  //     setProcessdone(false)
  //   });
  // }, [processdone]);

  useEffect(() => {
    setLoader(true);
    let requestID = localStorage.getItem("reqid");
    dispatch(FETCH_REQUEST_DASHBOARD_REPORT(requestID))
      .then((res) => {
        console.log("resApp", res);
        setAppointmentDetails(res);

        if (res.hospitalId) {
          dispatch(fetchVisitHistory(res.hospitalId))
            .then((visitRes) => {
              console.log("visitRes", visitRes);
              setVisitDetails(visitRes);
              setLoader(false);
            })
            .catch((error) => {
              console.error("Error fetching visit history:", error);
              setLoader(false);
            });
        } else {
          setLoader(false);
        }
      })
      .catch((error) => {
        console.error("Error fetching appointment details:", error);
        setLoader(false);
      });
  }, [processdone]);

  //let appointmentDetails = useSelector(state => state.requestDetails.requestDetails)
  let appointmentDetailsV2 = useSelector(
    (state) => state.interbranchAdmin.detaiedSelected
  );
  const toggleAcceptModal = (flag) => setAcceptModal(flag ? flag : false);
  const toggleReassignModal = (flag) => setReassignModal(flag ? flag : false);
  const toggleRejectModal = (flag) => setRejectModal(flag ? flag : false);
  const toggleInprogressModal = (flag) =>
    setInprogressModal(flag ? flag : false);

  // useEffect(() => {
  //   dispatch(fetchVisitHistory("1121053053")).then((res) => {
  //     console.log("visitRes", res);
  //     setVisitDetails(res);
  //   });
  // }, []);

  const formatVisitDate = (dateString) => {
    if (!dateString) return "";

    // Parse the date string to a Date object
    const date = parse(dateString, "dd-MM-yyyy HH:mm:ss", new Date());

    // Format the date to 'dd-MMM-yyyy'
    const formattedDate = format(date, "dd-MMM-yyyy");

    // Format the time to 'hh:mma'
    const formattedTime = format(date, "hh:mm a").toUpperCase();

    return `${formattedDate}, ${formattedTime}`;
  };

  console.log("appointmentDetails", appointmentDetails?.statusupdate);
  console.log("processdone", processdone);

  const loadMoreVisits = () => {
    const newVisitsToShow = visitsToShow + 5;
    setVisitsToShow(newVisitsToShow);

    if (newVisitsToShow >= visitDetails.output.length) {
      setShowLessButton(true);
    }
  };
  const visitHistoryRef = useRef(null);

  const showLessVisits = () => {
    setVisitsToShow(5);
    setShowLessButton(false);
    visitHistoryRef.current.scrollIntoView({ behavior: "smooth" });
  };

  console.log("Invoice", appointmentDetails?.Invoice);

  return (
    <div className="today-report-modal-content">
      {!loader ? (
        <>
          <div className="header">
            Request ID - {appointmentDetails?.requestID}
          </div>
          <div className="todays-report-timeline">
            <div>
              {(appointmentDetails?.appointmentStatus === "Requested" ||
                appointmentDetails?.appointmentStatus === "Inprogress") && (
                <ActionButtons
                  onAccept={() => {
                    setRequestedData(appointmentDetails);
                    toggleAcceptModal(true);
                  }}
                  onReject={() => {
                    setRequestedData(appointmentDetails);
                    toggleRejectModal(true);
                  }}
                  onStatus={() => {
                    setRequestedData(appointmentDetails);
                    toggleInprogressModal(true);
                  }}
                />
              )}
            </div>

            <table className="todays_report_table">
              <tbody>
                <tr>
                  <td className="title" colSpan={3}>
                    Appointment Details
                  </td>
                </tr>

                <tr>
                  <td className="cell1 even">Requested Date & Time</td>

                  <td className="cell3 even">
                    {appointmentDetails?.requesteddate}
                  </td>
                </tr>
                {appointmentDetails?.actiontakenDate != undefined &&
                  appointmentDetails?.actiontakenDate != "" && (
                    <tr>
                      <td className="cell1 even">Action taken Date & Time</td>

                      <td className="cell3 even">
                        {appointmentDetails?.appointmentStatus != "Requested"
                          ? appointmentDetails?.actiontakenDate
                          : "NA"}
                      </td>
                    </tr>
                  )}
                <tr>
                  <td className="cell1 even">Speciality Name</td>
                  <td className="cell3 odd">
                    {appointmentDetails &&
                    appointmentDetails.mainSpeciality !== ""
                      ? appointmentDetails.mainSpeciality
                      : "NA"}
                  </td>
                </tr>
                <tr>
                  <td className="cell1 even">Department Name</td>
                  <td className="cell3 odd">
                    {appointmentDetails &&
                    appointmentDetails.specialityName !== ""
                      ? appointmentDetails.specialityName
                      : "NA"}
                  </td>
                </tr>
                {/* <tr>
                    <td className='cell1 even'>Reason for Visit</td>

                    <td className='cell3 even'>{appointmentDetails?.reasonForVisit}</td>
                </tr> */}

                <tr>
                  <td className="cell1 even">Request Status</td>

                  <td className="cell3 even">
                    {appointmentDetails?.appointmentStatus}
                  </td>
                </tr>
                <tr>
                  {appointmentDetails?.reasonforcancel != "" &&
                    appointmentDetails?.reasonforcancel != undefined && (
                      <>
                        <td className="cell1 even">Reason for Rejection</td>
                        <td className="cell3 even">
                          {appointmentDetails?.reasonforcancel}
                        </td>
                      </>
                    )}
                </tr>

                <tr>
                  <td className="cell1 even">Payment Status</td>

                  <td className="cell3 even">Paid</td>
                </tr>
                {appointmentDetails?.helthDatafile != undefined &&
                  appointmentDetails?.helthDatafile != null &&
                  appointmentDetails?.helthDatafile != "" && (
                    <tr>
                      <td className="cell1 odd">Patient Health Info</td>
                      <td className="cell3 odd">
                        <a
                          className="Reportslink"
                          href={appointmentDetails?.helthDatafile}
                          target="_blank"
                        >
                          Health Info
                        </a>
                      </td>
                    </tr>
                  )}
                {appointmentDetails?.createdby ? (
                  <tr>
                    <td className="cell1 even">Created By</td>
                    <td className="cell3 even">
                      {appointmentDetails.createdby === "admin"
                        ? "Ganga Admin"
                        : appointmentDetails.createdby === "patient"
                        ? "Patient"
                        : appointmentDetails.createdby}
                    </td>
                  </tr>
                ) : null}
              </tbody>

              {Array.isArray(visitDetails.output) &&
                visitDetails.output.length > 0 && (
                  <tbody ref={visitHistoryRef}>
                    <tr>
                      <td className="title" colSpan={3}>
                        Visit History{" "}
                        <span style={{ fontWeight: "normal" }}>
                          ({visitDetails.output.length})
                        </span>
                      </td>
                    </tr>

                    {visitDetails.output
                      .slice()
                      .sort(
                        (a, b) => new Date(b.VisitDate) - new Date(a.VisitDate)
                      )
                      .slice(0, visitsToShow)
                      .map((visit, index) => (
                        <tr key={index}>
                          <td className="cell1 even" colSpan={3}>
                            <ul
                              style={{ marginBottom: "0", paddingLeft: "12px" }}
                            >
                              <li>
                                {formatVisitDate(visit?.VisitDate)}
                                <p
                                  className="cell3 even"
                                  style={{ marginBottom: "0" }}
                                >
                                  <div>
                                    {visit?.Doctor}, {visit?.Visit}/
                                    {visit?.Location}
                                  </div>
                                </p>
                              </li>
                            </ul>
                          </td>
                        </tr>
                      ))}
                    {visitsToShow < visitDetails.output.length && (
                      <tr
                        style={{
                          // display: "flex",
                          float: "right",
                          marginRight: "-258px",
                          // position: "relative",
                          marginTop: "-20px",
                        }}
                      >
                        <td
                          colSpan={2}
                          // style={{ position: "absolute", marginTop: "-60px", marginLeft:"159px" }}
                        >
                          <a
                            // href=""
                            onClick={loadMoreVisits}
                            // style={{ width: "100px", marginLeft: "130px" }}
                          >
                            <div style={{ color: "rgb(64, 169, 255)" }}>
                              Load More &gt;&gt;
                            </div>
                          </a>{" "}
                        </td>
                      </tr>
                    )}
                    {showLessButton && (
                      <tr
                        style={{
                          // display: "flex",
                          float: "right",
                          marginRight: "-258px",
                          // position: "relative",
                          marginTop: "-20px",
                        }}
                      >
                        <td colSpan={2}>
                          <a onClick={showLessVisits}>
                            <div style={{ color: "rgb(64, 169, 255)" }}>
                              Show Less &gt;&gt;
                            </div>
                          </a>
                        </td>
                      </tr>
                    )}
                  </tbody>
                )}

              {!Array.isArray(visitDetails.output) &&
                visitDetails.output &&
                Object.keys(visitDetails.output).length > 0 && (
                  <tbody>
                    {" "}
                    <tr>
                      {" "}
                      <td className="title" colSpan={3}>
                        {" "}
                        Visit History{" "}
                        <span style={{ fontWeight: "normal" }}>(1)</span>{" "}
                      </td>{" "}
                    </tr>{" "}
                    <tr>
                      {" "}
                      <td className="cell1 even" colSpan={3}>
                        {" "}
                        <ul style={{ marginBottom: "0", paddingLeft: "12px" }}>
                          {" "}
                          <li>
                            {" "}
                            {formatVisitDate(
                              visitDetails.output.VisitDate
                            )}{" "}
                            <p
                              className="cell3 even"
                              style={{ marginBottom: "0" }}
                            >
                              {" "}
                              <div>
                                {" "}
                                {visitDetails.output.Doctor},{" "}
                                {visitDetails.output.Visit}/
                                {visitDetails.output.Location}{" "}
                              </div>{" "}
                            </p>{" "}
                          </li>{" "}
                        </ul>{" "}
                      </td>{" "}
                    </tr>{" "}
                  </tbody>
                )}
              <tbody>
                <>
                  <tr>
                    <td className="title" colSpan={2}>
                      Timeline
                    </td>
                    <td className="title" colSpan={2}>
                      <Tooltip title="TAT is calculated from the time the appointment request is received.">
                        <InfoOutlinedIcon
                          style={{
                            color: "#69359b",
                            fontSize: "1.5em",
                            cursor: "pointer",
                          }}
                        />
                      </Tooltip>
                    </td>
                  </tr>

                  <tr>
                    {appointmentDetails?.requesteddate && (
                      <td className="cell1 even" colSpan={3}>
                        <ul style={{ marginBottom: "0", paddingLeft: "12px" }}>
                          <li>
                            Appointment Requested Date & Time
                            <p
                              className="cell3 even"
                              style={{ marginBottom: "0" }}
                            >
                              <div>{appointmentDetails?.requesteddate}</div>
                              {appointmentDetails?.actiontakenDate ? null : (
                                <p style={{ marginBottom: "0" }}>
                                  {`Pending from - ${appointmentDetails?.currentElapsedTime}`}
                                </p>
                              )}
                            </p>
                          </li>
                        </ul>
                      </td>
                    )}
                  </tr>
                  {/* {appointmentDetails?.statusupdate !== undefined && appointmentDetails?.statusupdate.length > 0 && (
                      <tr>
                        <td className="cell1 even" colSpan={3}>Status updates</td>
                      </tr>
                    )} */}

                  {appointmentDetails?.statusupdate !== undefined &&
                    appointmentDetails?.statusupdate?.length > 0 && (
                      <tr>
                        <td className="cell1 even" colSpan={3}>
                          <ul
                            style={{ marginBottom: "0", paddingLeft: "12px" }}
                            className="statuslist"
                          >
                            {appointmentDetails.statusupdate.map(
                              (item, index) => (
                                <li>
                                  Appointment Reviewed
                                  <p
                                    className="cell3 even"
                                    style={{ marginBottom: "0" }}
                                  >
                                    <div>{item?.reason}</div>

                                    <p style={{ marginBottom: "0" }}>
                                      {item?.actiontakenTime}
                                    </p>
                                  </p>
                                </li>
                              )
                            )}
                          </ul>
                        </td>
                      </tr>
                    )}

                  {appointmentDetails?.actiontakenDate && (
                    <tr>
                      <td className="cell1 even">
                        <ul style={{ marginBottom: "0", paddingLeft: "12px" }}>
                          <li>
                            {appointmentDetails?.appointmentStatus}
                            <p
                              className="cell3 even"
                              style={{ marginBottom: "0" }}
                            >
                              <>
                                <div>
                                  {appointmentDetails?.actiontakenDate || "NA"}
                                </div>
                                <span>
                                  {`TAT - ${
                                    !appointmentDetails?.elapsedTime?.includes(
                                      "0 hours"
                                    ) &&
                                    !appointmentDetails?.elapsedTime?.includes(
                                      "0 minutes"
                                    ) &&
                                    !appointmentDetails?.elapsedTime?.includes(
                                      "minutes"
                                    )
                                      ? appointmentDetails?.elapsedTime
                                      : appointmentDetails?.elapsedTime
                                          ?.replace("0 hours, ", "")
                                          ?.replace("hours, ", "hours")
                                          ?.replace("0 minutes", "")
                                          ?.replace(/\s*\d+\s*minutes?/, "")
                                          .replace(/, $/, "")
                                  }`}
                                </span>
                              </>
                            </p>
                          </li>
                        </ul>
                      </td>
                    </tr>
                  )}
                </>
              </tbody>

              {/* </div>
    </div> */}

              <tbody>
                <tr>
                  <td className="title" colSpan={6}>
                    Patient Complaint
                  </td>
                </tr>

                <tr>
                  {appointmentDetails?.notes != "" ? (
                    <td className="cell3 odd" colSpan={6}>
                      {appointmentDetails?.notes || "NA"}
                    </td>
                  ) : (
                    <td
                      className="cell3 odd"
                      colSpan={6}
                      style={{ textAlign: "center" }}
                    >
                      Not provided by Patient
                    </td>
                  )}
                </tr>
              </tbody>
              <tbody>
                <tr>
                  <td className="title" colSpan={6}>
                    Reports
                  </td>
                </tr>

                <tr>
                  {appointmentDetails != undefined &&
                  appointmentDetails.reports != undefined &&
                  appointmentDetails.reports.length > 0 ? (
                    <td className="cell3 odd">
                      <ul>
                        {appointmentDetails.reports.map((report, index) => (
                          <li className="Reports">
                            <a
                              className="Reportslink"
                              href={report.filecontent}
                              target="_blank"
                            >
                              Report {index + 1}
                            </a>
                          </li>
                        ))}
                      </ul>
                    </td>
                  ) : (
                    <td
                      className="cell3 odd"
                      colSpan={6}
                      style={{ textAlign: "center" }}
                    >
                      No Reports available
                    </td>
                  )}
                </tr>
              </tbody>

              <tbody>
                <tr>
                  <td className="title" colSpan={3}>
                    Patient Details
                  </td>
                </tr>

                <tr>
                  <td className="cell1 odd">Name</td>
                  <td className="cell3 odd">
                    {appointmentDetails?.patientname}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 odd">MRN Number</td>
                  <td className="cell3 odd">
                    {appointmentDetails?.hospitalId !== undefined &&
                    appointmentDetails?.hospitalId !== ""
                      ? appointmentDetails?.hospitalId
                      : "NA"}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 odd">Email ID</td>
                  <td className="cell3 odd">
                    {appointmentDetails?.patientEmailid}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 even">Phone Number</td>
                  <td className="cell3 even">
                    {appointmentDetails?.patientMobile}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 even">Gender</td>
                  <td className="cell3 even">{appointmentDetails?.gender}</td>
                </tr>
                <tr>
                  <td className="cell1 even">Date Of Birth</td>
                  <td className="cell3 even">
                    {appointmentDetails?.dob ? (
                      <>
                        {(() => {
                          const dob = appointmentDetails.dob;
                          const dobDate = new Date(dob);
                          const currentDate = new Date();
                          const ageInMonths = Math.floor(
                            (currentDate - dobDate) /
                              (1000 * 60 * 60 * 24 * 30.4375)
                          ); // Average number of days in a month
                          const ageInYears = Math.floor(ageInMonths / 12);

                          const formattedDob = new Intl.DateTimeFormat(
                            "en-GB",
                            { day: "2-digit", month: "short", year: "numeric" }
                          )
                            .format(dobDate)
                            .replace(/ /g, "/");

                          if (ageInMonths < 1) {
                            return `${formattedDob}, 1 month`;
                          } else if (ageInMonths < 12) {
                            return `${formattedDob}, ${ageInMonths} months`;
                          } else {
                            return `${formattedDob}, ${ageInYears} years`;
                          }
                        })()}
                      </>
                    ) : (
                      ""
                    )}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 even">Address</td>
                  <td className="cell3 even">
                    {/* {appointmentDetails?.patientaddress || "NA"} */}
                    {appointmentDetails &&
                    appointmentDetails.patientaddress !== ""
                      ? appointmentDetails.patientaddress
                      : "NA"}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 odd">Timezone</td>
                  <td className="cell3 odd">{appointmentDetails?.timezone}</td>
                </tr>

                <tr>
                  <td className="cell1 even">Booked By (For Loved One)</td>
                  <td className="cell3 even">
                    {appointmentDetails?.bookedby != undefined
                      ? appointmentDetails?.bookedby
                      : "NA"}
                  </td>
                </tr>

                {/* <tr>
                <td className="cell1 even">Browser</td>
                <td className="cell3 even">
                  {appointmentDetails && appointmentDetails.patientBrowser !== ""
                    ? appointmentDetails.patientBrowser
                    : "NA"}
                </td>
              </tr>

              <tr>
                <td className="cell1 even">OS</td>
                <td className="cell3 even">
                  {appointmentDetails && appointmentDetails.patientOs !== ""
                    ? appointmentDetails.patientOs
                    : "NA"}
                </td>
              </tr>

              <tr>
                <td className="cell1 even">User Agent</td>
                <td className="cell3 even">
                  {appointmentDetails && appointmentDetails.userAgent !== ""
                    ? appointmentDetails.userAgent
                    : "NA"}
                </td>
              </tr> */}
                {/* <tr>
                <td className="cell1 even">App Version</td>
                <td className="cell3 even">
                  {appointmentDetails && appointmentDetails.appVersion !== ""
                    ? appointmentDetails.appVersion
                    : "NA"}
                </td>
              </tr> */}
              </tbody>

              <tbody>
                <tr>
                  <td className="title" colSpan={3}>
                    Payment Details
                  </td>
                </tr>

                <tr>
                  <td className="cell1 odd">Payment Id</td>
                  <td className="cell3 odd">
                    {appointmentDetails?.paymentId || "NA"}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 odd">Payment Date & Time</td>
                  <td className="cell3 odd">
                    {appointmentDetails?.paymentdatetime || "NA"}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 odd">Fees Paid</td>
                  <td className="cell3 odd">
                    {appointmentDetails?.fees || "NA"}
                  </td>
                </tr>

                <tr>
                  <td className="cell1 odd">Payment Gateway</td>
                  <td className="cell3 odd">
                    {appointmentDetails?.paymentGateway || "NA"}
                  </td>
                </tr>
                <tr>
                  <td className="cell1 odd">Invoice file</td>
                  <td className="cell3 even">
                    {appointmentDetails?.Invoice != "-" ? (
                      <a href={appointmentDetails?.Invoice} target="_blank">
                        Invoice
                      </a>
                    ) : (
                      "NA"
                    )}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
          <AcceptModal
            open={acceptModal}
            togggle={toggleAcceptModal}
            onOk={() => {}}
            appointmentData={requestedData}
            setProcessdone={setProcessdone}
          />
          <AcceptModal
            isReassign
            setReassignData={setReassignData}
            reAssignData={reAssignData}
            open={reassignModal}
            togggle={toggleReassignModal}
            onOk={() => {}}
            appointmentData={requestedData}
            setProcessdone={setProcessdone}
          />
          <RejectModal
            open={rejectModal}
            togggle={toggleRejectModal}
            appointmentData={requestedData}
            setProcessdone={setProcessdone}
          />
          <InprogressModal
            open={inprogressModal}
            togggle={toggleInprogressModal}
            appointmentData={requestedData}
            setProcessdone={setProcessdone}
          />
        </>
      ) : (
        <div className="loader" style={{ width: "100%", textAlign: "center" }}>
          <Skeleton active />
        </div>
      )}
    </div>
  );
}

export default TodaysReportModalContent;

const ActionButtons = ({ onAccept, onReject, onStatus }) => {
  return (
    <div className={styles.actioButtonsWrap}>
      <button onClick={onStatus} className={styles.inprogressBtn}>
        In Progress
      </button>
      <button onClick={onAccept} className={styles.acceptBtn}>
        Accept
      </button>
      <button onClick={onReject} className={styles.rejectBtn}>
        Reject
      </button>
    </div>
  );
};

const AcceptModal = ({
  open,
  togggle,
  isReassign,
  reAssignData,
  setReassignData,
  appointmentData,
  setProcessdone,
}) => {
  let [timeSlots, setTimeSlots] = useState();
  const [form] = Form.useForm();
  let [doctors, setDoctors] = useState();
  const dispatch = useDispatch();
  const [userId, setUserId] = useState();
  const [isdisabled, setIsdisabled] = useState(false);

  const [specialities, setSpecialities] = useState([]);
  
  useEffect(() => {
    checUser();
    console.log("requestedData", appointmentData);
    if (appointmentData != undefined) {
      console.log("requestedData", appointmentData.doctorId);
     
    } else {
      console.log("requestedData", appointmentData);
    }
    
    if (isReassign && reAssignData) {
      form.setFieldsValue({
        appointmentDate: moment(reAssignData?.date),
        appointmentTime: "09:00 am",
        doctorName: doctors,
      });
    }
    dispatch(fetchallSpeciality("")).then((res) => {
                if (res) {
                  console.log("department", res);
                  const options = res.map((item) => ({
                    id: item.SpecialityId,
                    name: item.specialityName,
                  }));
                  setSpecialities(options);
                }
              });
  }, [open]);

  useEffect(() => {
    if (!open) {
      form.resetFields();
    }
  }, [open]);

  let checUser = async () => {
    getFromLocalStorage(USER_DATA).then((res) => {
      setUserId(JSON.parse(res).userId);
    });
  };

    const fetchDoctors = async (selectedDoctorValue) => {
        try {
          const consultationData = await dispatch(
            getdoctorbyspeciality(selectedDoctorValue,"Ganga Hospital")
          );
          setDoctors(consultationData);
          console.log("consultationData",consultationData)
        } catch (error) {
          console.error("Error fetching consultation and timezone data:", error);
        }
      };

  const getdoctorslis = () => {
    let doctorslist = [];
    if (doctors != undefined && doctors.length > 0) {
      doctors.map((eachAppointment, key) => {
        doctorslist.push({
          value: eachAppointment.doctorName,
          option: eachAppointment.doctorId,
        });
      });
    }
    return doctorslist;
  };

  const getConditionalText = (key) => {
    switch (key) {
      case "formCaption":
        return isReassign ? "Select" : "Confirm";
      case "submitText":
        return isReassign ? "Reassign" : "Assign";
      case "successMessage":
        return isReassign ? "Reassigned" : "Assigned";
      default:
        break;
    }
  };

  function handleAppointmentDateChange(e) {
    console.log("e", e);
    if (e != null) {
      let _timeSlots = createTimeSlots(e);
      setTimeSlots(_timeSlots);
    } else {
      setTimeSlots([]);
    }
  }

  function handleFormFinish(data) {
    //togggle(false);
    setIsdisabled(true);
    console.log("data", data);
    const momentObject = moment(data.appointmentDate, "DD-MMM-YYYY");
    console.log(
      "momentObject",
      momentObject.format("DD-MMM-YYYY") + " " + data.appointmentTime
    );
    console.log("appointmentData", appointmentData.requestID);

    let param = {
      process: "accept",
      appointmentId: appointmentData.requestID,
      UserId: userId,
      doctorId: data.doctorName,
      alternateDate:
        momentObject.format("DD-MMM-YYYY") + " " + data.appointmentTime,
    };

    dispatch(acceptrejectrequest(param)).then((res) => {
      console.log("res", res);
      if (
        res.info ===
        "Time slot already choosen by some other person. Please try with different slot, Sorry for the inconvenience."
      ) {
        setIsdisabled(false);
        message.success(
          `Time slot already chosen by some other person. Please try with different slot, Sorry for the inconvenience.`
        );
      } else {
        setIsdisabled(false);
        message.success(
          `Appointment ${getConditionalText("successMessage")} successfully`
        );
        togggle(false);
        setProcessdone(true);
        let params = {
          status: "Accepted",
          appointmentId: appointmentData.requestID,
          UserId: userId,
          reason: "Accepted",
        };
        console.log("param", params);

        // dispatch(changerequeststatus(params)).then((res) => {
        //   console.log("res", res);
        //   setProcessdone(true);
        // });
      }
    });
  }
  const { Option } = Select;

  return (
    <Modal
      className={`${styles.customModal} ${styles.customModalAccept}`}
      footer={false}
      closeIcon={<></>}
      header={null}
      open={open}
    >
      <Form
        form={form}
        onFinish={handleFormFinish}
        className={styles.accept_form}
      >
        <div className={styles.modalBody}>
          <div className={styles.formItem}>
            <div className={styles.formItemcaption}>
              {getConditionalText("formCaption")} the appointment date{" "}
              <span className={styles.mandatory}>*</span>
            </div>
            <div className={styles.formItemContent}>
              <Form.Item
                name="appointmentDate"
                rules={[
                  {
                    required: true,
                    message: "*Please Select Date",
                  },
                ]}
              >
                <DatePicker
                  format="DD-MMM-YYYY"
                  disabledDate={(current) =>
                    current.isBefore(moment().subtract(1, "day"))
                  }
                  onChange={handleAppointmentDateChange}
                />
              </Form.Item>
            </div>
          </div>

          <div className={styles.formItem}>
            <div className={styles.formItemcaption}>
              {getConditionalText("formCaption")} the appointment time{" "}
              <span className={styles.mandatory}>*</span>
            </div>
            <div className={styles.formItemContent}>
              <Form.Item
                name="appointmentTime"
                rules={[
                  {
                    required: true,
                    message: "*Please Select Time",
                  },
                ]}
              >
                <Select
                  options={createDropdownValues(timeSlots)}
                  allowClear
                  placeholder="Select time"
                />
              </Form.Item>
            </div>
          </div>

<div className={styles.formItem}>
            <div className={styles.formItemcaption}>
              {getConditionalText("formCaption")} the Speciality{" "}
              <span className={styles.mandatory}>*</span>
            </div>
            <div className={styles.formItemContent}>
              <Form.Item
                              name="speciality"
                              rules={[
                                {
                                  required: true,
                                  message: "*Please Select Speciality",
                                },
                              ]}
                            >
                              
                              <Select 
                                placeholder="Select Speciality"
                                onChange={(e) => {
                                  fetchDoctors(e)
                                   form.setFieldsValue({
                      doctorName: undefined
                    });
                                }}
                              >
                                {specialities != undefined &&
                                  specialities.map((option) => (
                                    <Option key={option.id} value={option.id}>
                                      {option.name}
                                    </Option>
                                  ))}
                              </Select>
                            </Form.Item>
            </div>
          </div>

          <div className={styles.formItem}>
            <div className={styles.formItemcaption}>
              {getConditionalText("formCaption")} the doctor{" "}
              <span className={styles.mandatory}>*</span>
            </div>
            <div className={styles.formItemContent}>
              <Form.Item
                name="doctorName"
                rules={[
                  {
                    required: true,
                    message: "*Please Select Doctor",
                  },
                ]}
              >
                {/* <Select
                    allowClear
                    defaultValue="Select Doctor"
                    //options={getdoctorslis()}
                    {doctors.map((option) => (
                      <Option key={option.value} value={option.value}>
                        {option.label}
                      </Option>
                    ))}
                      doctorslist.push({ value: eachAppointment.doctorName, option: eachAppointment.doctorName });
                    placeholder="Select Doctor"
                  /> */}
                <Select placeholder="Select Doctor">
                  {doctors != undefined &&
                    doctors.map((option) => (
                      <Option key={option.doctorId} value={option.doctorId}>
                        {option.doctorName}
                      </Option>
                    ))}
                </Select>
              </Form.Item>
            </div>
          </div>
        </div>

        <div className={styles.modalFooter}>
          <button
            type="button"
            className={styles.closeModalBtn}
            onClick={() => {
              togggle(false);
            }}
          >
            Close
          </button>
          <button
            type="submit"
            className={styles.acceptModalBtn}
            disabled={isdisabled}
          >
            {getConditionalText("submitText")}
          </button>
        </div>
      </Form>
    </Modal>
  );
};

const RejectModal = ({ open, togggle, appointmentData, setProcessdone }) => {
  const [userId, setUserId] = useState();
  useEffect(() => {
    checUser();
  }, [open]);
  let checUser = async () => {
    getFromLocalStorage(USER_DATA).then((res) => {
      setUserId(JSON.parse(res).userId);
    });
  };

  const options = [
    {
      label: "Multiple appointment requests",
      value: "Multiple appointment requests",
    },
    {
      label: "Referred to another Doctor/Specialist",
      value: "Referred to another Doctor/Specialist",
    },
    {
      label: "Met the doctor/Specialist in person",
      value: "Met the doctor/Specialist in person",
    },
    { label: "Direct walk-in", value: "Direct walk-in" },
    { label: "No consultation required", value: "No consultation required" },
    { label: "Doctor is not available", value: "Doctor is not available" },
    { label: "Doctor is on a vacation", value: "Doctor is on a vacation" },
    {
      label: "Doctor denied to take this Apmnt",
      value: "Doctor denied to take this Apmnt",
    },
    {
      label: "Patient denied the Apmnt date and time",
      value: "Patient denied the Apmnt date and time",
    },
    { label: "Done via Whatsapp", value: "Done via Whatsapp" },
    { label: "Done via Zoom", value: "Done via Zoom" },
    { label: "Doctor not available", value: "Doctor not available" },
    { label: "Patient not available", value: "Patient not available" },
    { label: "Refund", value: "Refund" },
    { label: "Refund Initiated", value: "Refund Initiated" },

    { label: "Others", value: "Others" },
  ];

  const [value, setValue] = useState();
  const [error, setError] = useState();
  const dispatch = useDispatch();

  function onChange(e) {
    console.log("onChange", e.target.value);
    setValue(e.target.value);
    if (!e.target.value) {
      setError(true);
    } else {
      setError(false);
    }
  }

  function handleRejectSubmit() {
    console.log("handleRejectSubmit", value);
    if (!value) {
      setError(true);
    } else {
      let param = {
        process: "cancel",
        appointmentId: appointmentData.requestID,
        // "UserId":userId,
        reason: value,
      };
      console.log("param", param);

      dispatch(acceptrejectrequest(param)).then((res) => {
        console.log("res", res);
        togggle(false);
        setProcessdone(true);
        let params = {
          status: "Rejected by Admin",
          appointmentId: appointmentData.requestID,
          UserId: userId,
          reason: "Rejected",
        };
        console.log("param", params);

        // dispatch(changerequeststatus(params)).then((res) => {
        //   console.log("res", res);
        //   setProcessdone(true);
        // });
      });
      message.success(`Appointment rejected`);
      setError(false);
      togggle(false);
      setValue("");
    }
  }

  return (
    <Modal
      className={`${styles.customModal} ${styles.customModalReject}`}
      footer={false}
      closeIcon={<></>}
      header={null}
      open={open}
    >
      <div className={styles.modalBody}>
        <h5>Select reason for rejection !</h5>

        <RadioGroup options={options} onChange={onChange} value={value} />
        {error ? (
          <span className={styles.validationError}>
            *Please select reason !!!
          </span>
        ) : (
          ""
        )}
      </div>

      <div className={styles.modalFooter}>
        <button
          className={styles.closeModalBtn}
          onClick={() => {
            togggle(false);
            setValue("");
          }}
        >
          Close
        </button>
        <button className={styles.rejectModalBtn} onClick={handleRejectSubmit}>
          Reject
        </button>
      </div>
    </Modal>
  );
};

const InprogressModal = ({
  open,
  togggle,
  appointmentData,
  setProcessdone,
}) => {
  const [userId, setUserId] = useState();
  useEffect(() => {
    checUser();
  }, [open]);
  let checUser = async () => {
    getFromLocalStorage(USER_DATA).then((res) => {
      setUserId(JSON.parse(res).userId);
    });
  };
  const options = [
    {
      label: "Acknowledged",
      value: "Acknowledged",
    },
    {
      label: "Waiting for reports",
      value: "Waiting for reports",
    },
    {
      label: "Doctor is not available",
      value: "Doctor is not available",
    },
    { label: "Patient is not available", value: "Patient is not available" },
    { label: "Direct walk-in", value: "Direct walk-in" },
    { label: "Patient not given time", value: "Patient not given time" },
  ];

  const [value, setValue] = useState();
  const [error, setError] = useState();
  const dispatch = useDispatch();

  function onChange(e) {
    console.log("onChange", e.target.value);
    setValue(e.target.value);
    if (!e.target.value) {
      setError(true);
    } else {
      setError(false);
    }
  }

  function handleRejectSubmit() {
    console.log("handleRejectSubmit", value);
    if (!value) {
      setError(true);
    } else {
      let param = {
        status: "Inprogress",
        appointmentId: appointmentData.requestID,
        UserId: userId,
        reason: value,
      };
      console.log("param", param);

      dispatch(changerequeststatus(param)).then((res) => {
        console.log("res", res);
        togggle(false);
        setProcessdone(true);
      });
      message.success(`Request status updated`);
      setError(false);
      togggle(false);
      setValue("");
    }
  }

  return (
    <Modal
      className={`${styles.customModal} ${styles.customModalReject}`}
      footer={false}
      closeIcon={<></>}
      header={null}
      open={open}
    >
      <div className={styles.modalBody}>
        <h5>Select reason for pending !</h5>

        <RadioGroup options={options} onChange={onChange} value={value} />
        {error ? (
          <span className={styles.validationError}>
            *Please select reason !!!
          </span>
        ) : (
          ""
        )}
      </div>

      <div className={styles.modalFooter}>
        <button
          className={styles.closeModalBtn}
          onClick={() => {
            togggle(false);
            setValue("");
          }}
        >
          Close
        </button>
        <button className={styles.rejectModalBtn} onClick={handleRejectSubmit}>
          Save
        </button>
      </div>
    </Modal>
  );
};
